import { render, staticRenderFns } from "./inspectionRecord.vue?vue&type=template&id=3a344d3c&scoped=true&"
import script from "./inspectionRecord.vue?vue&type=script&lang=js&"
export * from "./inspectionRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a344d3c",
  null
  
)

export default component.exports